import { useTokenAutoRefresh } from '../hooks/useTokenAutoRefresh';

/**
 * Componente che attiva l'auto-refresh del token quando "Remember me" è attivo.
 * Non renderizza nulla.
 */
export function TokenAutoRefresh(): null {
  useTokenAutoRefresh();
  return null;
}
